import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_ROUTES } from '@/constants/legalEntity';

interface LegalLinksProps {
  className?: string;
  separator?: string;
}

const LegalLinks: React.FC<LegalLinksProps> = ({ className = '', separator = ' · ' }) => {
  const links = [
    { label: 'Terms of Service', to: LEGAL_ROUTES.terms },
    { label: 'Privacy Policy', to: LEGAL_ROUTES.privacy },
    { label: 'Refund Policy', to: LEGAL_ROUTES.refund },
    { label: 'Cookie Policy', to: LEGAL_ROUTES.cookies },
  ];

  return (
    <nav className={`flex flex-wrap items-center gap-1 ${className}`} aria-label="Legal policies">
      {links.map((link, i) => (
        <React.Fragment key={link.to}>
          {i > 0 && <span className="text-slate-400">{separator}</span>}
          <Link to={link.to} className="text-slate-600 hover:text-violet-700 transition-colors">
            {link.label}
          </Link>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default LegalLinks;
